import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=bb84fe4e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb84fe4e')) {
      api.createRecord('bb84fe4e', component.options)
    } else {
      api.reload('bb84fe4e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=bb84fe4e&", function () {
      api.rerender('bb84fe4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lbuk5VZWZ3dF/JS/comp/IncreaseNumber.vue"
export default component.exports